import { createApp as c, reactive as r } from "vue";
import { useExpose as u, extend as m } from "../composables/use-expose.js";
const d = (o) => {
  const t = c(o), e = document.createElement("div");
  return document.body.appendChild(e), {
    instance: t.mount(e),
    unmount() {
      t.unmount(), document.body.removeChild(e);
    }
  };
}, a = () => {
  const o = r({
    visible: !0
  }), t = (n) => {
    o.visible = n;
  }, e = (n) => {
    m(o, n), t(!0);
  }, s = () => {
    t(!1);
  };
  return u({ open: e, close: s, toggle: t }), {
    state: o,
    open: e,
    close: s,
    toggle: t
  };
};
export {
  d as mountComponent,
  a as usePopupState
};
